import {ReactNode, useEffect} from "react";
import {FormProvider, useForm, useWatch} from "react-hook-form";

import {IFormProps} from "@pg-mono/form";

import {creditContributionDefault} from "../../../credit_calculator/constants/credit_contribution_default";
import {creditPeriodDefault} from "../../../credit_calculator/constants/credit_period_default";
import {calculateInstallment} from "../../../credit_calculator/utils/calculate_installment";
import {budgetFilterDefaults} from "../../../real_estate/constants/budget_filter_defaults";
import {IRealEstateFiltersForm} from "../../../real_estate/types/IRealEstateFiltersForm";
import {convertToBudgetFilterDefaultValues} from "../../../real_estate/utils/convert_to_budget_filter_default_values";
import {Currency} from "../../../types/Currency";
import {ISearchFiltersFormValues} from "../../types/ISearchFiltersFormValues";
import {ISearchFiltersSlot} from "../../types/ISearchFiltersSlot";
import {ISearchFormValues} from "../../types/ISearchFormValues";
import {IRealEstateFiltersConfig} from "../../types/RealEstateFiltersConfig";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";
import {FilterBudget} from "./FilterBudget";
import {RealEstateLegacyFilter} from "./RealEstateLegacyFilter";

interface IProps {
    formValues: ISearchFiltersFormValues;
    filtersConfig: IRealEstateFiltersConfig;
    filtersSlots: ISearchFiltersSlot[];
    legacyFormProps: IFormProps<ISearchFiltersFormValues>;
    currency?: Currency;
    filterRender: (filterSlot: ISearchFiltersSlot, filter: ReactNode) => ReactNode;
}

export const RealEstateFilters = (props: IProps) => {
    const {formValues, filtersConfig, filtersSlots, legacyFormProps, currency, filterRender} = props;

    const formMethods = useForm({
        defaultValues: convertToBudgetFilterDefaultValues(formValues as ISearchFormValues, "max", filtersConfig.budget.maxPrice)
    });

    return (
        <FormProvider {...formMethods}>
            <LegacyFormHandler legacyFormProps={legacyFormProps} maxPrice={filtersConfig.budget.maxPrice} />
            {filtersSlots.map((filterSlot) => {
                const filter = <FilterSlot filterSlot={filterSlot} currency={currency} filtersConfig={filtersConfig} legacyFormProps={legacyFormProps} />;

                return filterRender(filterSlot, filter);
            })}
        </FormProvider>
    );
};

function FilterSlot(props: {
    filterSlot: ISearchFiltersSlot;
    filtersConfig: IRealEstateFiltersConfig;
    legacyFormProps: IFormProps<ISearchFiltersFormValues>;
    currency?: Currency;
}) {
    const {filterSlot, currency, filtersConfig, legacyFormProps} = props;

    const filterConfig = filterSlot.filters[0];

    if (filterSlot.rhfFilter && filterConfig.type === SearchFilterTypes.BUDGET) {
        return <FilterBudget key={filterSlot.id} currency={currency} maxPrice={filtersConfig.budget.maxPrice} maxDisplayLabel="bez limitu" />;
    }

    return (
        <RealEstateLegacyFilter
            key={filterSlot.id}
            filter={filterConfig}
            currency={currency}
            {...legacyFormProps.getFieldProps(filterSlot.id as keyof ISearchFiltersFormValues)}
        />
    );
}

interface ILegacyFormHandlerProps {
    legacyFormProps: IFormProps<ISearchFiltersFormValues>;
    maxPrice: number;
}

/**
 * To keep legacy/redux form updated with values from rhf
 * Currently, only budget is from rhf.
 * In case any new rhf field is added, add it here.
 * In the end, when whole form is based on rhf, this can be removed.
 */
function LegacyFormHandler(props: ILegacyFormHandlerProps) {
    const {legacyFormProps, maxPrice} = props;

    const price = useWatch<Pick<IRealEstateFiltersForm, "budgetTotal">>({name: "budgetTotal"});
    const instalment = useWatch<Pick<IRealEstateFiltersForm, "budgetCredit">>({name: "budgetCredit"});
    const radioType = useWatch<Pick<IRealEstateFiltersForm, "filterBudget">>({name: "filterBudget"});

    const monthlyMax = Math.round(calculateInstallment(maxPrice, creditContributionDefault, creditPeriodDefault) || 0) || budgetFilterDefaults.monthlyMax;

    useEffect(() => {
        const legacyFormPrice = parseInt(legacyFormProps.values.price.upper) || 0;
        const isMaxTotalValue = maxPrice <= price;

        if (radioType === "total" && legacyFormProps.onChange && price && legacyFormPrice !== price) {
            legacyFormProps.onChange({price: {lower: "", upper: isMaxTotalValue ? "" : price.toString()}, instalment: ""});
        }

        const legacyFormInstalment = legacyFormProps.values.instalment || 0;
        const isMaxMonthlyValue = monthlyMax <= instalment;

        if (radioType === "monthly" && legacyFormProps.onChange && instalment && legacyFormInstalment !== instalment) {
            legacyFormProps.onChange({instalment: isMaxMonthlyValue ? "" : instalment, price: {lower: "", upper: ""}});
        }
    }, [price, instalment, radioType]);

    return null;
}
import {ReactNode, useEffect} from "react";
import {FormProvider, useForm, useWatch} from "react-hook-form";

import {IFormProps} from "@pg-mono/form";

import {creditContributionDefault} from "../../../credit_calculator/constants/credit_contribution_default";
import {creditPeriodDefault} from "../../../credit_calculator/constants/credit_period_default";
import {calculateInstallment} from "../../../credit_calculator/utils/calculate_installment";
import {budgetFilterDefaults} from "../../../real_estate/constants/budget_filter_defaults";
import {IRealEstateFiltersForm} from "../../../real_estate/types/IRealEstateFiltersForm";
import {convertToBudgetFilterDefaultValues} from "../../../real_estate/utils/convert_to_budget_filter_default_values";
import {Currency} from "../../../types/Currency";
import {ISearchFiltersFormValues} from "../../types/ISearchFiltersFormValues";
import {ISearchFiltersSlot} from "../../types/ISearchFiltersSlot";
import {ISearchFormValues} from "../../types/ISearchFormValues";
import {IRealEstateFiltersConfig} from "../../types/RealEstateFiltersConfig";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";
import {FilterBudget} from "./FilterBudget";
import {RealEstateLegacyFilter} from "./RealEstateLegacyFilter";

interface IProps {
    formValues: ISearchFiltersFormValues;
    filtersConfig: IRealEstateFiltersConfig;
    filtersSlots: ISearchFiltersSlot[];
    legacyFormProps: IFormProps<ISearchFiltersFormValues>;
    currency?: Currency;
    filterRender: (filterSlot: ISearchFiltersSlot, filter: ReactNode) => ReactNode;
}

export const RealEstateFilters = (props: IProps) => {
    const {formValues, filtersConfig, filtersSlots, legacyFormProps, currency, filterRender} = props;

    const formMethods = useForm({
        defaultValues: convertToBudgetFilterDefaultValues(formValues as ISearchFormValues, "max", filtersConfig.budget.maxPrice)
    });

    return (
        <FormProvider {...formMethods}>
            <LegacyFormHandler legacyFormProps={legacyFormProps} maxPrice={filtersConfig.budget.maxPrice} />
            {filtersSlots.map((filterSlot) => {
                const filter = <FilterSlot filterSlot={filterSlot} currency={currency} filtersConfig={filtersConfig} legacyFormProps={legacyFormProps} />;

                return filterRender(filterSlot, filter);
            })}
        </FormProvider>
    );
};

function FilterSlot(props: {
    filterSlot: ISearchFiltersSlot;
    filtersConfig: IRealEstateFiltersConfig;
    legacyFormProps: IFormProps<ISearchFiltersFormValues>;
    currency?: Currency;
}) {
    const {filterSlot, currency, filtersConfig, legacyFormProps} = props;

    const filterConfig = filterSlot.filters[0];

    if (filterSlot.rhfFilter && filterConfig.type === SearchFilterTypes.BUDGET) {
        return <FilterBudget key={filterSlot.id} currency={currency} maxPrice={filtersConfig.budget.maxPrice} maxDisplayLabel="bez limitu" />;
    }

    return (
        <RealEstateLegacyFilter
            key={filterSlot.id}
            filter={filterConfig}
            currency={currency}
            {...legacyFormProps.getFieldProps(filterSlot.id as keyof ISearchFiltersFormValues)}
        />
    );
}

interface ILegacyFormHandlerProps {
    legacyFormProps: IFormProps<ISearchFiltersFormValues>;
    maxPrice: number;
}

/**
 * To keep legacy/redux form updated with values from rhf
 * Currently, only budget is from rhf.
 * In case any new rhf field is added, add it here.
 * In the end, when whole form is based on rhf, this can be removed.
 */
function LegacyFormHandler(props: ILegacyFormHandlerProps) {
    const {legacyFormProps, maxPrice} = props;

    const price = useWatch<Pick<IRealEstateFiltersForm, "budgetTotal">>({name: "budgetTotal"});
    const instalment = useWatch<Pick<IRealEstateFiltersForm, "budgetCredit">>({name: "budgetCredit"});
    const radioType = useWatch<Pick<IRealEstateFiltersForm, "filterBudget">>({name: "filterBudget"});

    const monthlyMax = Math.round(calculateInstallment(maxPrice, creditContributionDefault, creditPeriodDefault) || 0) || budgetFilterDefaults.monthlyMax;

    useEffect(() => {
        const legacyFormPrice = parseInt(legacyFormProps.values.price.upper) || 0;
        const isMaxTotalValue = maxPrice <= price;

        if (radioType === "total" && legacyFormProps.onChange && price && legacyFormPrice !== price) {
            legacyFormProps.onChange({price: {lower: "", upper: isMaxTotalValue ? "" : price.toString()}, instalment: ""});
        }

        const legacyFormInstalment = legacyFormProps.values.instalment || 0;
        const isMaxMonthlyValue = monthlyMax <= instalment;

        if (radioType === "monthly" && legacyFormProps.onChange && instalment && legacyFormInstalment !== instalment) {
            legacyFormProps.onChange({instalment: isMaxMonthlyValue ? "" : instalment, price: {lower: "", upper: ""}});
        }
    }, [price, instalment, radioType]);

    return null;
}
